import { render, staticRenderFns } from "./Minderlieferung.vue?vue&type=template&id=ad1531ca&scoped=true"
import script from "./Minderlieferung.vue?vue&type=script&lang=js"
export * from "./Minderlieferung.vue?vue&type=script&lang=js"
import style0 from "./Minderlieferung.vue?vue&type=style&index=0&id=ad1531ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1531ca",
  null
  
)

export default component.exports